import type {
  IDisablePropSDKProps,
  IDisabledPropSDK,
} from '@wix/editor-elements-corvid-utils';
import {
  composeSDKFactories,
  clickPropsSDKFactory,
  focusPropsSDKFactory,
  disablePropsSDKFactory,
  createElementPropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import {
  accessibilityPropsSDKFactory,
  stylableButtonSDKFactory,
} from '../../../StylableButton/corvid/StylableButton.corvid';
import type {
  IStylableButtonProps,
  IStylableButtonSDK,
} from '../../../StylableButton/StylableButton.types';
import type { ISlideshowButtonPropSDKProps } from '../../types';

const slideshowButtonSDKFactory: CorvidSDKPropsFactory<
  IDisablePropSDKProps & ISlideshowButtonPropSDKProps,
  Pick<IDisabledPropSDK, 'enabled'>
> = api => {
  const { props } = api;

  return {
    get enabled() {
      if (props.isDisabled === undefined) {
        return !props.isDisabledByCtx;
      }
      return !props.isDisabled;
    },
  };
};

const elementPropsSDKFactory = createElementPropsSDKFactory();

export const sdk = composeSDKFactories<
  IStylableButtonProps,
  IStylableButtonSDK
>([
  elementPropsSDKFactory,
  clickPropsSDKFactory,
  focusPropsSDKFactory,
  disablePropsSDKFactory,
  accessibilityPropsSDKFactory,
  stylableButtonSDKFactory,
  slideshowButtonSDKFactory,
]);

export default createComponentSDKModel(sdk);
